import { Route, createBrowserRouter, createRoutesFromElements, RouterProvider } from 'react-router-dom';
// import { Join, Joiner } from './pages/Join';
import { Player } from './player/Player';
import { Content } from './components/Content';
import { Home } from './pages/Home';
import { NotFound } from './pages/NotFound';
import ReactGA from 'react-ga4';
import { Capture } from './player/Capture';
import { MobileGamepadPage } from './player/MobileGamepad';
import { Fullscreen } from './player/Fullscreen';
import { Ios } from './pages/Ios';
// import { Joiner } from './pages/Joiner';
import { Sts } from './pages/Sts';
import { DevOverlay } from './components/dev/DevOverlay';
import { ShowDev } from './components/dev/ShowDev';
import { Toaster } from '@playcastdotio/Shadcn';
import { useUser } from '@clerk/clerk-react';
import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { Joiner } from './pages/Joiner2';

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path='/' element={<Content />}>
        <Route index element={<Home />} />
        <Route path='ios' element={<Ios />} />
        <Route path='j/:joinId' element={<Joiner />} />
        {/* <Route path='j/:host' element={<Joiner />} />
        <Route path='join' element={<Join />} /> */}
      </Route>
      <Route path='/player' element={<Player />} />
      <Route path='/sts' element={<Sts />} />
      {/* <Route path='/deck' element={<Deck />} /> */}
      {/* <Route path='/queue' element={<Queue />} /> */}
      <Route path='/capture' element={<Capture />} />
      <Route path='/mobile-gamepad' element={<MobileGamepadPage />} />
      <Route path='/fullscreen' element={<Fullscreen />} />
      <Route path='/showdev' element={<ShowDev />} />

      <Route path='*' element={<NotFound />} />
    </>,
  ),
);

export const App = () => {
  const user = useUser();
  useEffect(() => {
    if (user) {
      const username = user.user?.username ?? user.user?.fullName ?? undefined;
      const email = user.user?.primaryEmailAddress?.emailAddress;
      const id = user.user?.id;
      if (email && id) {
        localStorage.setItem('clerkUserID', id ?? '');
        if (Sentry.isInitialized()) {
          Sentry.setUser({
            username,
            email,
            id,
            ip_address: '{{auto}}',
          });
          console.log('Sentry.setUser');
        }
        ReactGA.set({ user_id: id });
      }
    }
  }, [user]);

  return (
    <>
      <Toaster richColors position='top-center' />
      <DevOverlay />
      <RouterProvider router={router} />
    </>
  );
};
